
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/our-portfolio/[...pagepath]",
      function () {
        return require("private-next-pages/portfolio/our-portfolio/[...pagepath]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio/our-portfolio/[...pagepath]"])
      });
    }
  